import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { contentfulClient } from '../config/contentful.ts';

function BlogPage() {
  const { id } = useParams();
  const [blogPost, setBlogPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogPost = async () => {
      try {
        const response = await contentfulClient.getEntry(id);
        setBlogPost(response.fields);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogPost();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!blogPost) return <div>Blog post not found</div>;

  return (
    <article className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          {blogPost.image && (
            <img 
              src={blogPost.image.fields.file.url} 
              alt={blogPost.image.fields.title}
              className="img-fluid rounded mb-4 w-100"
            />
          )}
          <h1 className="display-4 mb-4">{blogPost.title}</h1>
          
          <div className="content">
            {blogPost.content.content.map((item, index) => {
              switch (item.nodeType) {
                case 'heading-2':
                  return <h2 key={index} className="h2 mt-5 mb-4">{item.content[0].value}</h2>;
                case 'heading-3':
                  return <h3 key={index} className="h3 mt-4 mb-3">{item.content[0].value}</h3>;
                case 'paragraph':
                  return <p key={index} className="lead mb-3">{item.content[0].value}</p>;
                case 'unordered-list':
                  return (
                    <ul key={index} className="list-group list-group-flush mb-4">
                      {item.content.map((listItem, listIndex) => (
                        <li key={listIndex} className="list-group-item bg-transparent">
                          {listItem.content[0].content.map((content, contentIndex) => (
                            <span key={contentIndex} className={content.marks?.some(mark => mark.type === 'bold') ? 'fw-bold' : ''}>
                              {content.value}
                            </span>
                          ))}
                        </li>
                      ))}
                    </ul>
                  );
                default:
                  return null;
              }
            })}
          </div>
        </div>
      </div>
    </article>
  );
}

export default BlogPage; 